import { handleError, showError, showSuccess } from './utils';

export const signup = (signupData) => handleError(async (dispatch, getState, { api }) => {
  await api.signup(signupData);
  showSuccess({ text: '¡Created Account!. Please verify your email to get more information to log in' });

  return true;
}, 'Sign Up Attempt Unsuccessful');

export const login = (loginData) => handleError(async (dispatch, getState, { api }) => {
  await api.login(loginData);

  return true;
}, 'Log In Attempt Unsuccessful');

export const forgotPassword = (forgotPasswordInfo) => handleError(async (dispatch, getState, { api }) => {
  const res = await api.forgotPassword(forgotPasswordInfo);

  if (res === 200) {
    showSuccess({ text: 'An email was sent to your account' });
    return true;
  }

  showError({ text: 'An error occurred when sending the email' });
  return true;
}, 'Unsuccessful attempt');

export const logout = () => handleError(async (dispatch, getState, { api }) => {
  await api.logout();
  return true;
}, 'Log Out Attempt Unsuccessful');